// Component with css height depends on Media Queries

import React from 'react'
import cx from 'classnames'

import s from './HeaderHeight.scss'


const HeaderHeight = ({ children, className }) => (
  <div className={cx(s.headerHeight, className)}>
    {children}
  </div>
)

export default HeaderHeight
